import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { PENDING_ORGANIZATION_INVITATIONS } from "./pendingOrganizationInvitations";

export const ACCEPT_ORGANIZATION_INVITATION = gql(`
  mutation ACCEPT_ORGANIZATION_INVITATION($invitationId: ID!)  {
    organizationInvitationAccept(invitationId: $invitationId) {
      __typename
      ... on Organization {
        id
        name
        slug
      }
      ... on OrganizationNotFound {
        id
      }
    }
  }
`);

export const useAcceptOrganizationInvitation = () => {
  const mutation = useMutation(ACCEPT_ORGANIZATION_INVITATION, {
    update: (cache, { data }, { variables }) => {
      const mutationSuccess =
        data?.organizationInvitationAccept?.__typename === "Organization";
      if (!mutationSuccess) return cache;

      const invitationId = variables?.invitationId;
      if (!invitationId) return cache;

      cache.updateQuery(
        { query: PENDING_ORGANIZATION_INVITATIONS },
        (cachedPendingInvitationsQuery) => {
          if (!cachedPendingInvitationsQuery) return null;

          const cachedPendingInvitations =
            cachedPendingInvitationsQuery.me.pendingInvitations.filter(
              (i) => i.id !== invitationId
            ) || [];

          return {
            ...cachedPendingInvitationsQuery,
            me: {
              ...cachedPendingInvitationsQuery.me,
              pendingInvitations: cachedPendingInvitations
            }
          };
        }
      );

      return cache;
    }
  });
  return mutation;
};
